import { UserTaskStatus, UserTaskType } from "@/enums/mateEnums";
import { get, post, put } from "@/modules/request";
import {
  ItemResponse,
  PageRequest,
  Response,
  WriteResponse,
} from "@/types/api-types";
import { UserTask, TaskReward } from "@/types/entity";

// 获取用户任务列表
export const ApiGetUserTaskPage = (
  params: PageRequest<{
    status?: UserTaskStatus;
    type?: UserTaskType;
  }>
): Promise<{
  page: {
    data: Array<UserTask>;
    static: {
      total: number;
      inProgress: number;
      completed: number;
      claimed: number;
    };
  };
}> => get("/UserTaskPage", params);

// 获取单个任务详情
export const ApiGetUserTask = (id: number): Promise<Response<UserTask>> =>
  get(`/UserTask/${id}`);

// 更新任务进度
export const ApiUpdateUserTaskProgress = (
  id: number,
  progress: number
): Promise<WriteResponse<UserTask>> =>
  put(`/UserTask/${id}/progress`, { progress });

// 领取任务奖励
export const ApiClaimTaskReward = (
  id: number
): Promise<Response<ItemResponse<TaskReward>>> => post(`/UserTask/${id}/claim`);
